module.exports = __webpack_public_path__ + "img/are.9fd1fcbf.svg";